import React, { Component } from 'react';
import "../../styles/reports/reports.scss";

class ReportButtonGroup extends Component {
    buttonClick = () => {
        this.props.function();
    }
    render() {
        return (
            <div className="inputWrapper">

                <div className="inputGroup">
                    <input className="" placeholder={`${this.props.placeholder}`} type="text" disabled></input>
                    <button onClick={this.buttonClick}>
                        <i className={`fa ${this.props.icon}`} />
                    </button>
                </div>
                {this.props.dropDown}
            </div>
        );
    }
}

export default ReportButtonGroup;
